import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Dropdown from '../../ui/dropdown';
import { useNavigate } from "react-router";

import Globals, { Keywords } from '../../../utility/constants/appConstants';

import Storage from '../../../utility/features/helpers/storageHelper';
import { filterServiceAgeement, filterInvoice } from '../../../utility/features/helpers/serviceDetailsHelper';
import serviceDetailsClient from '../../../utility/apiClients/account/serviceDetailsClient';
import customerSummaryClient from '../../../utility/apiClients/customer/customerSummaryClient';
import NoServices from './noServices';
import { OneTimeEasyPayService } from './serviceTilesEasyPay';
import { PrePayServices } from './servicesTilesPrePay';
import ServiceInvoices from './serviceInvoices';
import ServiceBottomTab from './serviceBottomTab';
import Error from '../../errorMessage';
import Loader from "../../loader"
import { Pagination } from "../../Pagination";
import "../../../styles/pagination.css";
import { IsLoggedIn } from '../../../utility/features/helpers/authHelper';
import {setCustomerInfo} from "../../../reduxStore/login/loginSlice";
import {invoiceAmountDue } from '../../../utility/features/helpers/accountHelper';
import paymentStatusClient from '../../../utility/apiClients/payments/paymentStatusClient';
import missionStatusClient from '../../../utility/apiClients/user/missionStatusClient';

const ServiceDetails = ({serviceDetailsCss}) => {
    const dispatch = useDispatch();
    const nav = useNavigate();
    const customerSummary = useSelector((state) => state.login.customerInfo);
    const selectedServiceAddress = useSelector((state) => state.accountSummary.selectedServiceAddress);
    const [unauthorizeResponse, setUnauthorizeResponse] = useState(false);
    const custNumbers = JSON.parse(localStorage.getItem("customerNumbers")) || [];  
    const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);

    const labels = Globals.acc;
    const currentYear = parseInt((new Date()).getFullYear());
    const [data, setData] = useState({
      year: currentYear,
      yearOptions: null,
      data: null,
      serviceDetails: null,
      rescheduleData: null,
      hideButton: false,
      prefText: Keywords.prefTextList[0],
      typeList: null,
      resClientCallStatus:' ',
      salesAgrNum: null,
      custPrefStatus: false,
      isActiveCustomer: true,
      inActiveMessage: "",
      isLoading: true
    });
    const [errMsg, setErrMsg] = useState("");
    const clientCallRef = useRef(null);

    const missionStatusCheck = async () => {
        try {
            const missionStatus = await missionStatusClient();
            return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
        } catch (err) {
            console.error("Error checking mission status api:", err);
            return false;
        }
    };

    const customerNumber = customerSummary?customerSummary[0].CustomerNumber:"";
    const serviceAddress = customerSummary?customerSummary[0].ServiceAddresses[0].address:"";
    const [fServiceAgreements, setFServiceAgreements] = useState([]);
    const [allInvoices, setAllInvoices] = useState([]);

    const [invoiceStatuses, setInvoiceStatuses] = useState({
        processing: [],
        failed: [],
        success: [],
        not_found: [],
        onqueue: [],
        pending:[]
    });

    const getCustomerSummary = async (custNum) => {
        if(custNum === "") return;

        const isMissionAvailable = await missionStatusCheck();
        if (!isMissionAvailable) {
            setErrMsg(labels.missionDownErrorDisplay);
            setData(prev => ({...prev, isLoading: false}));
            return;
        }

        try{
            const customerSummary = await customerSummaryClient(custNum);
            
            if (customerSummary?.status && customerSummary?.status === 401 ) {
              console.log("Unauthorized access - 401");
              localStorage.clear();
              nav("/login", { replace: true });
              return;
            }

            if(customerSummary?.data === null || customerSummary?.data === undefined){
              setErrMsg("Some error occurred.");
              return
            }
            
            dispatch(setCustomerInfo(customerSummary?.data));
            
        } catch(err){
            setErrMsg("Some error occurred.");
        } finally {
            
        }
    }

    useEffect(() => {
      if(global.window){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'pageVirtualMetaData',
          'page' : {
            'name' : 'Service Details',
            'type' : 'Information Page',
            'section' : 'Account',
            'customer_id': (Storage.customerNumber() || {}),
            'virtual' : {
              'path' : window.location.pathname,
              'referral' : window.document.referrer
            },
            'loyalty_eligible': JSON.parse(localStorage.getItem("loyalty_eligible")),
            'loyalty_member': JSON.parse(localStorage.getItem("loyaltyFlag")),
            'loyalty_redemption': JSON.parse(localStorage.getItem("loyaltyRedemptionFlag"))
          }
        });
      }

    }, []);

    useEffect(() => {
      if (!IsLoggedIn() || unauthorizeResponse || serviceAddress == "" || customerNumber == "") {
        
        (async() => {
          await getCustomerSummary(custNumbers[0]);
        })()
      }
    }, [unauthorizeResponse, serviceAddress, customerNumber]);

    useEffect(() => {
      setErrMsg("");
      setData(prev => ({...prev, serviceDetails:null, isLoading:true}));

      if(selectedServiceAddress != null){
        const [serviceAddress, customerNumber] = selectedServiceAddress.split(" | ");
        
        if(clientCallRef.current != selectedServiceAddress){
          
          clientCallRef.current = selectedServiceAddress;
          if(allCustomersApiCalled)
            clientCalls(customerNumber, serviceAddress);
        }
      } else if(customerNumber != "" && serviceAddress != "") {
        if(clientCallRef.current != serviceAddress+" | "+customerNumber){
          clientCallRef.current = serviceAddress+" | "+customerNumber;
          if(allCustomersApiCalled){
            clientCalls(customerNumber, serviceAddress);
          }
        }
        else{
          if(allCustomersApiCalled){
            clientCalls(customerNumber, serviceAddress);
          }
        }
      }
    }, [selectedServiceAddress, serviceAddress, customerNumber, allCustomersApiCalled]);

    const handleSelect = (e) => {
      
      e.preventDefault(); //prevent default submit
      const year = parseInt(e.target.value);
      setTimeout(() => {
        setData({ ...data, year });
      }, 100);
      
    }

    const clientCalls = async (customerNumber, address) => {
      
      const isMissionAvailable = await missionStatusCheck();
      if (!isMissionAvailable) {
          setErrMsg(labels.missionDownErrorDisplay);
          setData(prev => ({...prev, isLoading: false}));
          return;
      }

      setData({ ...data, isLoading: true });
      serviceDetailsClient(customerNumber, address).then(
        (response) => {

          if(response.CODE && response.CODE === "ER" && response.DESCRIPTION && response.DESCRIPTION === "NO ACTIVE CUSTOMER INFORMATION"){
            setData({...data, isActiveCustomer: false, inActiveMessage: response.DESCRIPTION, isLoading: false});
            return;
          } else if (response?.errorStatus === 401) {
            // Flag unauthorized → handle in effect below
            setUnauthorizeResponse(true);
          } else if(response.errorMsg && response.errorStatus) {
            setErrMsg("Some error occurred.");
          } else if(response.status === 424) {
            setErrMsg("Some Error Occured.");
          } else if(response.status === 500) {
            setErrMsg("Some Error Occured.");
          } else {
            const serviceDetails = response;
            let yearOptions = response?.InvoiceYears?.map((year) => (year));
            let currentYearCheck = yearOptions && yearOptions.filter((year) => year === currentYear);
            if (currentYearCheck && currentYearCheck.length < 1) {
              yearOptions.push(currentYear);
            }
            yearOptions = yearOptions && yearOptions.reverse();
            let stateYearCheck = yearOptions && yearOptions.filter((year) => year === parseInt(data.year));
            if (stateYearCheck && stateYearCheck < 1) {
              
              setData({...data, year: currentYear});
              
            }
            
            setData({ ...data, serviceDetails, yearOptions, isLoading: false });
          }
        },
        (error) => {
          setErrMsg("Some error occurred.");
          
          setData({...data, isLoading: false});
        }
      );
    }

    const checkPaymentStatus = async () => {
      
      const isMissionAvailable = await missionStatusCheck();
      if (!isMissionAvailable) {
          setErrMsg(labels.missionDownErrorDisplay);
          return;
      }

      const allPaidInvoices = allInvoices.map(sa => ({ invoiceNumber: sa.invoiceNo, saNumber: sa.salesAgrNum }));

      try {
          const response = await paymentStatusClient(allPaidInvoices);
              
          if (response?.error) {
              setErrMsg("Some error occurred.");
          } else if (response?.data) {
              // Process the payment status response
              const processing = [];
              const failed = [];
              const success = [];
              const not_found = [];
              const onqueue = [];
              const pending = [];
            
              response?.data.forEach(item => {
                  const invoiceNumber = item.invoice_number;
                  const status = item.status.toLowerCase();

                  if (status === 'processing' || status === 'in-progress') {
                      processing.push(invoiceNumber);
                  } else if (status === 'failed') {
                      failed.push(invoiceNumber);
                  } else if (status === 'success') {
                      success.push(invoiceNumber);
                  }else if (status === 'not_found') {
                      not_found.push(invoiceNumber);
                  }else if (status === 'onqueue') {
                      onqueue.push(invoiceNumber);
                  }else if (status === 'pending') {
                      pending.push(invoiceNumber);
                  }
              });

              setInvoiceStatuses({ processing, failed, success, not_found, onqueue, pending });
              
          } else {
            setErrMsg("Some error occurred.");
          }
      } catch (err) {
          console.error('Error checking payment status:', err);
          setErrMsg("Some error occurred.");
      } finally {}
    };

    const hideButtonCall = () => {
      setData({ ...data, hideButton: true }); 
    };

    const { serviceDetails, yearOptions, year, rescheduleData, hideButton, prefText, salesAgrNum, typeList, resClientCallStatus, isActiveCustomer, inActiveMessage, isLoading} = data;
    useEffect(() => {
      setFServiceAgreements(filterServiceAgeement(serviceDetails, year));
    }, [serviceDetails, year]);

    useEffect(() => {
      if(fServiceAgreements.length > 0){
        
        let activeServiceAgreements = [];
        fServiceAgreements.forEach(invoice => {
            // if sales agreement has bad debt, do not show invoice
            if (invoice.isBadSalesAgreement !== 'N' && invoiceAmountDue(invoice) > 0 && invoice.inactiveReason !== 'SSP' && invoice.inactiveReason !== 'NRN') return null;
            
            if(invoice?.Invoices.length > 0){
              invoice?.Invoices.forEach(inv => {
                  if (inv.invoiceBalance > 0 && inv.invoiceOpen === "Y") {
                    activeServiceAgreements.push({
                        payTotalPymt: inv.invoiceBalance,
                        salesAgrNum: inv?.salesAgrNum,
                        invoiceNo: inv?.invoiceNum,
                        invoiceAmt: inv?.invoiceBalance,
                        payBunit: invoice?.asgBunit,
                        svcLineDesc: inv?.svcServiceLine,
                        dueDate: inv?.invoiceDate,
                    });
                  }
              });
            }
        });
        
        // Remove duplicates from activeServiceAgreements based on invoiceNo
        const uniqueActiveServiceAgreements = activeServiceAgreements.filter((item, index, self) =>
            index === self.findIndex((t) => t.invoiceNo === item.invoiceNo)
        );
        
        setAllInvoices(uniqueActiveServiceAgreements);
      }
    }, [fServiceAgreements]);

    useEffect(() => {
      if(allInvoices.length > 0){
        
        (async () => await checkPaymentStatus())();
      }
    }, [allInvoices]);

    /* pagination */
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const totalItems = fServiceAgreements?fServiceAgreements.length:0;

    const pageData = useMemo(() => {
      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      return fServiceAgreements?fServiceAgreements.slice(start, end):[];
    }, [fServiceAgreements, page, pageSize]);

    
    useEffect(() => {
      const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
      if (page > totalPages) setPage(totalPages);
    }, [totalItems, pageSize]);
    /* pagination */

    const serviceComponent = (serviceDetailsCss) => {
      if (!serviceDetails && rescheduleData.data && rescheduleData.data.reschedulablewoNumber && rescheduleData.data.reschedulablewoNumber.length > 0) return '';
      let serviceComponent = <NoServices serviceDetailsCss={serviceDetailsCss} labels={labels} />;
      if (serviceDetails) {
        if (pageData.length > 0) {
          serviceComponent = <>
            {pageData.map((service, i) => <Services invoiceStatuses={invoiceStatuses} allInvoices={allInvoices} serviceDetailsCss={serviceDetailsCss} data={service} labels={labels} year={year} key={i} hideButton={hideButtonCall} salesAgrNum={salesAgrNum} typeList={typeList} resClientCallStatus={resClientCallStatus} serviceListCall={() => clientCalls(customerNumber, serviceAddress)} />)}
            {totalItems > pageSize && <div className={`pagination-container`}>
                          
              <Pagination
                currentPage={page}
                totalItems={totalItems}
                pageSize={pageSize}
                onPageChange={setPage}
                maxButtons={7}
              />

              {/* Optional page size selector */}
              <label className={`per-page-container`}>
                <span  className={`page-num`}>Rows per page&nbsp;&nbsp;</span>
                <select
                  className={`rounded-0`}
                  value={pageSize}
                  onChange={(e) => setPageSize(parseInt(e.target.value, 10))}
                >
                  {[10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </label>
            </div>}
          </>;
        }
      }
      return serviceComponent;
    };
    return (
      <>
        {errMsg == "" && isLoading && <Loader />}
        <div class="bg-green d-md-none my-20 py-20 row d-md-none">
          <div class={`col-12 ${serviceDetailsCss['gfw-3']} glh-1_1 text-white tru-mma-mobile-current`}>
            <span class="d-block gfs-30 mb-6">Service Details</span>
            <span class={`d-block ${serviceDetailsCss['gfs-20']}`}>Get information about your plans or services and view invoices.</span>
          </div>
        </div>
        {errMsg != "" && <Error labels={labels} errMsg={errMsg} />}
        {errMsg == "" && !isLoading && serviceDetails != null &&
          <div className={`bg-gray-100 mb-40 p-md-30 mb-40 tru-mma-main-wrapper ${serviceDetailsCss["tru-mma-main-wrapper--summary"]}`}>
            <div className='row justify-content-md-end'>
              <div className='col-12 col-md-3 col-lg-2' >
                <div className='tru-mma-select tg-mb-15'>
                  <form>
                    {yearOptions && <Dropdown options={yearOptions} value={year} className={`ShowLoadingModal ${serviceDetailsCss['service-year-dropdown']} ${serviceDetailsCss['gfs-16']} ${serviceDetailsCss['gfw-3']} w-100`} onChange={handleSelect} />}
                  </form>
                </div>
              </div>
            </div>
            {serviceComponent(serviceDetailsCss)}
          </div>
        }

        {errMsg == "" && !isLoading && !isActiveCustomer && <div className={`bg-gray-100 mb-40 p-md-30 mb-40 tru-mma-main-wrapper ${serviceDetailsCss["tru-mma-main-wrapper--summary"]}`}>
            <div className='container-fluid'>
              <div className='row'>
                <div className={`col-12 ${serviceDetailsCss['gfs-20']} mb-20 p-0`}>
                  <span className={`${serviceDetailsCss['gfw-7']} text-uppercase`}>{inActiveMessage}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
}

function Services({ invoiceStatuses, allInvoices, serviceDetailsCss, data, labels, year, onReschedule, hideButton, salesAgrNum, typeList, resClientCallStatus, serviceListCall }) {
  const saNum = data.salesAgrNum;

  /* invoice status */
  let invoice = data.Invoices.length > 0?data.Invoices[0]:null;
  
  const isProcessing = invoice && invoiceStatuses?invoiceStatuses.processing.includes(invoice.invoiceNo):false;
  const isFailed = invoice && invoiceStatuses?invoiceStatuses.failed.includes(invoice.invoiceNo):false;
  const isNotFound = invoice && invoiceStatuses?invoiceStatuses.not_found.includes(invoice.invoiceNo):false;
  const isOnQueue = invoice && invoiceStatuses?invoiceStatuses.onqueue.includes(invoice.invoiceNo):false;
  const isPending = invoice && invoiceStatuses?invoiceStatuses.pending.includes(invoice.invoiceNo):false;
  const isSuccess = invoice && invoiceStatuses?invoiceStatuses.success.includes(invoice.invoiceNo):false;
  const isActionEnabled = !(isProcessing || isOnQueue || isPending || isSuccess);
  

  return (
    <div className={`${serviceDetailsCss['service-detail-box']} container-fluid mt-30`}>
      <div className={`row ${serviceDetailsCss['tru-mma-main-content-box']} tg-mb-0`}>
        <div className={`col-12 ${serviceDetailsCss['gfw-3']} p-16 ${serviceDetailsCss['tru-mma-main-content']}`}>
          <div className='row mb-16 mb-md-10'>
            <div className='col-12 col-md-7'>
              <div className={`${serviceDetailsCss['gfs-24']} glh-1 ${serviceDetailsCss['mb-10']}`}>
                {data.svcLineDesc}
              </div>
            </div>
          </div>
          {(data.ServiceAgreementType === 'PrePay') ?
            <PrePayServices isActionEnabled={isActionEnabled} serviceDetailsCss={serviceDetailsCss} data={data} labels={labels} year={year} /> :
            <OneTimeEasyPayService isActionEnabled={isActionEnabled} serviceDetailsCss={serviceDetailsCss} data={data} labels={labels} year={year} />
          }
          <ServiceBottomTab serviceDetailsCss={serviceDetailsCss} data={data} labels={labels} year={year} hideButton={hideButton} salesAgrNum={salesAgrNum} typeList={typeList} resClientCallStatus={resClientCallStatus} serviceListCall={() => serviceListCall()} />
        </div>
      </div>
      {((data.Invoices).length > 0) ? (filterInvoice(data.Invoices, year).length > 0 && <ServiceInvoices serviceDetailsCss={serviceDetailsCss} invoices={filterInvoice(data.Invoices, year)} labels={labels} id={data.salesAgrNum} />) : ' '}
    </div>
  );
}

export default ServiceDetails;



